import { Speaker } from "@/states/call/speakers/speakers.utility.decl";

export function getLeftPercentage(startTime: number, length: number) {
  if (length === 0) {
    return 0;
  }
  return (startTime * 100) / length;
}

export function getWidthPercentage(start: number, end: number, length: number) {
  if (length === 0) {
    return 0;
  }
  return ((end - start) * 100) / length;
}

// We are checking if it's a number since 0 is also a valid option
export const getColor = (speaker: Speaker | undefined) =>
  speaker && Number.isInteger(speaker?.agentID) ? "primary" : "informative";
